import { OperationReelle } from '../models/operation-reelle.model';

export function filtrerOperationsReellesParMois(
  operations: OperationReelle[],
  annee: number,
  mois: number
): OperationReelle[] {
  return operations
    .filter((op) => {
      const anneeOp = parseInt(op.dateOperation.substring(0, 4), 10);
      const moisOp = parseInt(op.dateOperation.substring(5, 7), 10);
      return anneeOp === annee && moisOp === mois;
    })
    .sort((a, b) => b.dateOperation.localeCompare(a.dateOperation));
}

export function totalOperationsReelles(operations: OperationReelle[]): number {
  return operations.reduce((total, op) => total + op.montant, 0);
}
